var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTemperature = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 17.5834V4.91675C12.7499 3.65697 12.2495 2.44879 11.3587 1.55799C10.4679 0.667193 9.2597 0.166748 7.99992 0.166748C6.74014 0.166748 5.53196 0.667193 4.64116 1.55799C3.75036 2.44879 3.24992 3.65697 3.24992 4.91675V17.5834C1.92066 18.5804 0.938779 19.9703 0.443353 21.5563C-0.0520732 23.1422 -0.0359251 24.8439 0.489509 26.4202C1.01494 27.9965 2.02303 29.3675 3.37096 30.3391C4.7189 31.3106 6.33835 31.8334 7.99992 31.8334C9.66149 31.8334 11.2809 31.3106 12.6289 30.3391C13.9768 29.3675 14.9849 27.9965 15.5103 26.4202C16.0358 24.8439 16.0519 23.1422 15.5565 21.5563C15.0611 19.9703 14.0792 18.5804 12.7499 17.5834ZM7.99992 3.33341C8.41984 3.33341 8.82257 3.50023 9.1195 3.79716C9.41644 4.0941 9.58325 4.49682 9.58325 4.91675V16.0001H6.41659V4.91675C6.41659 4.49682 6.5834 4.0941 6.88033 3.79716C7.17727 3.50023 7.57999 3.33341 7.99992 3.33341Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTemperature);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/temperature.e58b73585440b35663e6badb6a95fa47.svg";